module.exports = __webpack_public_path__ + "img/shfw.8c7a71df.png";